import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import HowToFix from '../shared/HowToFix';
import InlineModal from '../shared/InlineModal';

export default function Http2Section({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;
    const hasResources = result.non_http2_resources && Object.entries(result.non_http2_resources).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {hasResources && <Http2Result nonHttp2Resources={result.non_http2_resources} />}

                {hasResources && result.how_to_fix && (
                    <HowToFix
                        title={title}
                        howToFix={result.how_to_fix}
                        howToFixVideo={result.how_to_fix_video}
                    />
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type Http2ResultProps = {
    nonHttp2Resources: {
        [key: string]: any[];
    };
};

function Http2Result({ nonHttp2Resources }: Http2ResultProps) {
    return (
        <div className="description-meta">
            <InlineModal
                openLabel="See results list"
                modalTitle="Full list of non-http2 resources"
                closeLabel="Close"
            >
                {Object.entries(nonHttp2Resources).map(([host, items], idx) => {
                    return (
                        <div key={idx}>
                            <div className="list-title">From {host}:</div>
                            <ul className="bulleted-list">
                                {items.map((item, itemIdx) => {
                                    return (
                                        <li key={itemIdx}>
                                            <a
                                                href={item.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {item.url}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    );
                })}
            </InlineModal>
        </div>
    );
}
